import * as Types from '@battlefly/__generated__/globalTypes';

import { gql } from '@apollo/client';
import { CoreModBlueprintFieldsFragmentDoc } from '../../graphql/__generated__/fragments';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetBattleFlyCombatLogHistoryQueryVariables = Types.Exact<{
  battleFlyId?: Types.InputMaybe<Types.Scalars['ID']>;
  first?: Types.InputMaybe<Types.Scalars['Int']>;
  returnTotalCount?: Types.InputMaybe<Types.Scalars['Boolean']>;
  after?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type GetBattleFlyCombatLogHistoryQuery = { __typename?: 'Query', getBattleFly: { __typename?: 'GenericBattleFly', battleFly: { __typename?: 'BattleFly', location: Types.BattleFlyLocation, combatHistoryPaginated: { __typename?: 'PaginatedCombatLog', pageInfo: { __typename?: 'PageInfo', endCursor: string | null, hasNextPage: boolean } | null, edges: Array<{ __typename?: 'CombatLogEdge', node: { __typename?: 'Combat', id: string, location: string, createdAt: any, matchTimestamp: any, battleFlyLooser: { __typename?: 'BattleFly', id: string, name: string, league: Types.BattleFlyLeague, placeInGlobalLeaderboard: number, starsRate: number, rarity: Types.Rarity | null, appearance: { __typename?: 'BattleFlyAppearance', image: string | null } }, battleFlyWinner: { __typename?: 'BattleFly', id: string, name: string, league: Types.BattleFlyLeague, placeInGlobalLeaderboard: number, starsRate: number, rarity: Types.Rarity | null, appearance: { __typename?: 'BattleFlyAppearance', image: string | null } }, log: { __typename?: 'CombatLog', participants: Array<{ __typename?: 'LogParticipant', battleFlyId: number | null, weapons: Array<{ __typename?: 'LogModInfo', name: string, blueprint: { __typename?: 'ModBlueprint', category: string, description: string, type: Types.ModType, id: string, rarity: Types.Rarity, name: string, appearance: { __typename?: 'ModAppearance', image: string | null, model: string, location: string | null }, weapon: { __typename?: 'WeaponBlueprint', reload: number, damagePerFire: number, burst: number } | null, defense: { __typename?: 'DefenseBlueprint', shield: number, armor: number, evasion: number } | null } }>, defense: Array<{ __typename?: 'LogModInfo', name: string, blueprint: { __typename?: 'ModBlueprint', category: string, description: string, type: Types.ModType, id: string, rarity: Types.Rarity, name: string, appearance: { __typename?: 'ModAppearance', image: string | null, model: string, location: string | null }, weapon: { __typename?: 'WeaponBlueprint', reload: number, damagePerFire: number, burst: number } | null, defense: { __typename?: 'DefenseBlueprint', shield: number, armor: number, evasion: number } | null } }>, utilities: Array<{ __typename?: 'LogModInfo', name: string, blueprint: { __typename?: 'ModBlueprint', category: string, description: string, type: Types.ModType, id: string, rarity: Types.Rarity, name: string, appearance: { __typename?: 'ModAppearance', image: string | null, model: string, location: string | null }, weapon: { __typename?: 'WeaponBlueprint', reload: number, damagePerFire: number, burst: number } | null, defense: { __typename?: 'DefenseBlueprint', shield: number, armor: number, evasion: number } | null } }> }> } } }> | null } } | null } | null };


export const GetBattleFlyCombatLogHistoryDocument = gql`
    query GetBattleFlyCombatLogHistory($battleFlyId: ID, $first: Int, $returnTotalCount: Boolean, $after: String) {
  getBattleFly(input: {battleFlyId: $battleFlyId}) {
    battleFly {
      location
      combatHistoryPaginated(
        first: $first
        returnTotalCount: $returnTotalCount
        after: $after
      ) {
        pageInfo {
          endCursor
          hasNextPage
        }
        edges {
          node {
            id
            location
            createdAt
            matchTimestamp
            battleFlyLooser {
              id
              name
              appearance {
                image
              }
              league
              placeInGlobalLeaderboard
              starsRate
              rarity
            }
            battleFlyWinner {
              id
              name
              appearance {
                image
              }
              league
              placeInGlobalLeaderboard
              starsRate
              rarity
            }
            log {
              participants {
                battleFlyId
                weapons {
                  name
                  blueprint {
                    ...CoreModBlueprintFields
                  }
                }
                defense {
                  name
                  blueprint {
                    ...CoreModBlueprintFields
                  }
                }
                utilities {
                  name
                  blueprint {
                    ...CoreModBlueprintFields
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${CoreModBlueprintFieldsFragmentDoc}`;

/**
 * __useGetBattleFlyCombatLogHistoryQuery__
 *
 * To run a query within a React component, call `useGetBattleFlyCombatLogHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBattleFlyCombatLogHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBattleFlyCombatLogHistoryQuery({
 *   variables: {
 *      battleFlyId: // value for 'battleFlyId'
 *      first: // value for 'first'
 *      returnTotalCount: // value for 'returnTotalCount'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetBattleFlyCombatLogHistoryQuery(baseOptions?: Apollo.QueryHookOptions<GetBattleFlyCombatLogHistoryQuery, GetBattleFlyCombatLogHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBattleFlyCombatLogHistoryQuery, GetBattleFlyCombatLogHistoryQueryVariables>(GetBattleFlyCombatLogHistoryDocument, options);
      }
export function useGetBattleFlyCombatLogHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBattleFlyCombatLogHistoryQuery, GetBattleFlyCombatLogHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBattleFlyCombatLogHistoryQuery, GetBattleFlyCombatLogHistoryQueryVariables>(GetBattleFlyCombatLogHistoryDocument, options);
        }
export type GetBattleFlyCombatLogHistoryQueryHookResult = ReturnType<typeof useGetBattleFlyCombatLogHistoryQuery>;
export type GetBattleFlyCombatLogHistoryLazyQueryHookResult = ReturnType<typeof useGetBattleFlyCombatLogHistoryLazyQuery>;
export type GetBattleFlyCombatLogHistoryQueryResult = Apollo.QueryResult<GetBattleFlyCombatLogHistoryQuery, GetBattleFlyCombatLogHistoryQueryVariables>;